if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    async onSubmitHandler(evt) {

      // Makes the button 
      this.querySelector('.prov-add-to-cart-btn').classList.add('prov-add-to-cart-btn-accent-2')
      evt.preventDefault();

      if (document.querySelector('.product-custom-print-options') &&
        document.querySelector('.custom-print-option').getAttribute('aria-selected') === "true" &&
      (document.querySelector('#custom-print-text').value.length < 1 || document.querySelector('#custom-print-number').value.length < 1)) {
        document.querySelector('.custom-print-error-message').style.display = "block";
        return
      } else {
        if (document.querySelector('.product-custom-print-options')) {
          document.querySelector('.custom-print-error-message').style.display = "none";
        }
      }

      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      const products = []

      const mainProduct = {
        id: formData.get('id'),
        quantity: formData.get('quantity'),
      }
      
      // Generate unique ID for shirt value

      // Title, size, custom print & sleeve
      const title = document.querySelector('.product__title').textContent?.trim();
      const size = document.querySelector('.prov-product-size-variant-container input[type=radio]:checked')?.value;
      const shirtPrintValue = formData.get('properties[Shirt printing]')?.trim();
      const sleevePatchValue = formData.get('properties[Sleeve patch]')?.trim();
      const flamingoSleevePatchValue = formData.get('properties[Flamingo patch]')?.trim();

      const initialsValue = formData.get('properties[Initials]')?.trim();
      const numArr = new Uint32Array(4);
      const randomNumbers = window.crypto.getRandomValues(numArr).join('')

      const uniqueId = title+size+shirtPrintValue+sleevePatchValue+initialsValue+randomNumbers
      
      // If user selected custom print
      const customPrintProductConfig = {}
      if (formData.has('properties[Shirt printing]')) {
        customPrintProductConfig['id'] = formData.get('properties[Shirt print id]');
        customPrintProductConfig['quantity'] = formData.get('quantity');
        customPrintProductConfig.properties = {}
        customPrintProductConfig.properties['Shirt printing'] = shirtPrintValue;
        customPrintProductConfig.properties['_unique_id'] = uniqueId;

        products.push(customPrintProductConfig)
        
        mainProduct.properties = {}
        mainProduct.properties['Shirt printing'] = shirtPrintValue;
        mainProduct.properties['_unique_id'] = uniqueId;
      }

      if (formData.has('properties[Sleeve patch]') || formData.has('properties[Flamingo patch]')) {

        if (!mainProduct.properties) mainProduct.properties = {}
        mainProduct.properties['_unique_id'] = uniqueId;

        if(formData.has('properties[Sleeve patch]')) {
          mainProduct.properties['Sleeve patch'] = sleevePatchValue;
          const sleevePatchProduct = {}
          sleevePatchProduct['id'] = sleeve_patch_product_id;
          sleevePatchProduct['quantity'] = formData.get('quantity');
          sleevePatchProduct.properties = {}
          if (shirtPrintValue) {
            sleevePatchProduct.properties['Shirt printing'] = shirtPrintValue;
          }
          sleevePatchProduct.properties['Shirt'] = title;
          sleevePatchProduct.properties['Product size'] = size;
          sleevePatchProduct.properties['_unique_id'] = uniqueId;

          products.push(sleevePatchProduct)
        }

        if(formData.has('properties[Flamingo patch]')) {
          const flamingoSleevePatchProductId = document.querySelector('input[name="properties[Flamingo patch]"]').dataset.productid;
          mainProduct.properties['Flamingo patch'] = flamingoSleevePatchValue;
          const flamingoPatchProduct = {}
          flamingoPatchProduct['id'] = flamingoSleevePatchProductId;
          flamingoPatchProduct['quantity'] = formData.get('quantity');
          flamingoPatchProduct.properties = {}
          if (shirtPrintValue) {
            flamingoPatchProduct.properties['Shirt printing'] = shirtPrintValue;
          }
          flamingoPatchProduct.properties['Shirt'] = title;
          flamingoPatchProduct.properties['Product size'] = size;
          flamingoPatchProduct.properties['_unique_id'] = uniqueId;
          products.push(flamingoPatchProduct)
        }

      }

      // Product initials
      if (formData.has('properties[Initials]')) {
        if (!mainProduct.properties) mainProduct.properties = {}
        
        mainProduct.properties['Initials'] = initialsValue.toUpperCase();
        mainProduct.properties['_unique_id'] = uniqueId;

        const initalsProduct = {}
        initalsProduct['id'] = product_initials_id;
        initalsProduct['quantity'] = formData.get('quantity');
        initalsProduct.properties = {}
        if (initialsValue) {
          initalsProduct.properties['Initials'] = initialsValue.toUpperCase();
        }
        initalsProduct.properties['Product'] = title;
        initalsProduct.properties['_unique_id'] = uniqueId;
        products.push(initalsProduct)
      }
      
      products.push(mainProduct)
      
      //checking if buffer is available
      if(window.productBuffer !== undefined && window.productBuffer !== null) {
        let totalProducts = Number(window.productBuffer.quantity) - Number(window.productBuffer.buffer);

        this.checkProductQuantityInCart(mainProduct.id).then(cartQuantity => {
          if((totalProducts - cartQuantity) >= Number(mainProduct.quantity)) {
            this.addProductToCart(products, formData, mainProduct, submitButton);
          } else {
            this.handleErrorMessage(`You can add up to ${totalProducts} to your cart`)
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          }
        });
      } else {
        this.addProductToCart(products, formData, mainProduct, submitButton);
      }
    }
    
    addProductToCart(products, formData, mainProduct, submitButton) {

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: products,
          sections : 'cart-notification-product,cart-notification-button,cart-icon-bubble',
          sections_url: formData.get('sections_url')
        })
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            this.querySelector('.prov-add-to-cart-btn').classList.remove('prov-add-to-cart-btn-accent-2')
            return;
          }
          this.querySelector('.prov-add-to-cart-text').innerHTML = "Item added to cart"
          setTimeout(() => {
            this.querySelector('.prov-add-to-cart-text').innerHTML = "Add to cart"
            this.querySelector('.prov-add-to-cart-btn').classList.remove('prov-add-to-cart-btn-accent-2')
          }, 1500)

          // Returns array of items if user selected custom print and/or sleeve print. Need to parse data 
          // because more than 1 product variant has been added to the basket
          if (response?.items) {
            const product = response.items.filter((prod) => prod.id === +mainProduct.id)
            const filteredRespData = {...product[0], sections: response.sections}
            this.cartNotification.renderContents(filteredRespData);
          } else {
            this.cartNotification.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });

    }

    async checkProductQuantityInCart(productID) {
      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();

        let quantity = 0;
        for (let i = 0; i < cart.items.length; i++) {
          if (cart.items[i].id == productID) {
            quantity = cart.items[i].quantity;
          }
        }
        return quantity;
      } catch (error) {
        console.error(`Error getting quantity from cart: ${error}`);
      }
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
